module.exports = __webpack_public_path__ + "img/scene_candlelight_big@2x.22e30ed3.png";